import { ChangeDetectionStrategy, Component, computed, effect, Signal, signal, untracked } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DeliveryTypeMultiSelectComponent } from '../../../delivery';
import { ReportParameterBase } from './report-parameter-base';

@Component({
    selector: 'app-delivery-type-multi-select-parameter',
    imports: [DeliveryTypeMultiSelectComponent],
    template: `
        <app-delivery-type-multi-select
            [selectedDeliveryTypeKeys]="deliveryTypeKeys()"
            [id]="parameterDefinition().key"
            [subscriberKey]="subscriberKey()"
            [placeHolder]="subscriberKey() != null ? parameterDefinition().placeholder : 'Select a subscriber first'"
            [invalid]="isInvalid()"
            [disabled]="isDisabled()"
            (blur)="onBlur()"
            (loadingChange)="onLoadingChange($event)"
            (selectedDeliveryTypeKeysChange)="onSelectedDeliveryTypeKeysChange($event)"
        />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: DeliveryTypeMultiSelectParameterComponent,
            multi: true
        }
    ]
})
export class DeliveryTypeMultiSelectParameterComponent extends ReportParameterBase<number[]> {
    deliveryTypeKeys = signal<number[]>([]);
    subscriberKey: Signal<number | null> = this.reportWorkspace.subscriberKey;

    override isDisabled = computed(() => this.reportWorkspace.isReportRunning() || this.isFormControlDisabled() || !this.subscriberKey());

    constructor() {
        super();

        /* Clear Options when Subscriber Changes */
        effect(() => {
            this.subscriberKey();
            const parameterDefinition = untracked(this.parameterDefinition);

            if (!this.isInitialized) {
                return;
            }

            const value = (parameterDefinition.emptyValue as number[]) ?? [];

            this.deliveryTypeKeys.set(value);
            this.reportWorkspace.setParam(parameterDefinition.key, value);
            this.onChange(value);

            this.formControl?.markAsUntouched();
            this.formControl?.markAsPristine();
        });
    }

    onSelectedDeliveryTypeKeysChange(deliveryTypeKeys: number[]) {
        this.deliveryTypeKeys.set(deliveryTypeKeys);

        this.reportWorkspace.setParam(this.parameterDefinition().key, deliveryTypeKeys);

        this.onChange(deliveryTypeKeys);
        this.markTouchedIfNotResetting();
    }

    onLoadingChange(loading: boolean) {
        this.reportWorkspace.setParamLoading(this.parameterDefinition().key, loading);
    }

    onBlur() {
        this.onTouched();
    }

    // CVA callbacks
    writeValue(obj: number[]): void {
        this.deliveryTypeKeys.set(obj);
    }
}
